
































































import { Component, Prop, Vue } from "vue-property-decorator";
import {
  db,
  storage,
  storageBucket,
  inventoryCollection,
  imageThumbnails,
  Timestamp,
} from "../db";
import draggable from "vuedraggable";
import store from "../store";
import { image } from "vee-validate/dist/rules";

interface UploadResult {
  url: string;
  thumbnailUrl0: string;
  thumbnailUrl1: string;
  name: string;
}

@Component({
  components: {
    draggable,
  },
})
export default class EquipmentImagesEdit extends Vue {
  private images: any[] = [];
  private imageResolution = 50;
  @Prop({ required: true })
  public item: any;

  private files: any[] = [];
  private isError = false;
  private errorText = "";

  created() {
    this.$bind(
      "images",
      db.collection(`inventory/${this.item.id}/images`).orderBy("order", "asc")
    );
  }

  async onAddFiles(files) {
    if (files.length > 0) {
      files.forEach((file) => {
        this.files.push({ name: file.name, type: "info" });
      });
      files.forEach(async (file) => {
        const result = await this.uploadFileToFirebase(file);

        if (this.images.length == 0) {
          inventoryCollection
            .doc(`${this.item.id}`)
            .update({ imageUrl: result.thumbnailUrl1 });
        }

        // Add to image collection
        db.collection(`inventory/${this.item.id}/images/`).add({
          order: this.images.length, // due to delay in local update, increase this locally and it will be updated again later by server
          ...result,
        });

        this.updateStatus(file.name, "success");
        this.imagesUpdated();
      });
    }
  }

  updateStatus(name, type) {
    //upload status
    const fileStatus = this.files.find((x) => x.name == name);
    if (fileStatus != null) {
      fileStatus.type = type;
    }
  }

  async uploadFileToFirebase(file): Promise<any> {
    const metadata = {
      contentType: file.type,
      cacheControl: "public,max-age=86400",
    };
    const updateStatus = this.updateStatus;
    const getThumbnailName = this.getThumbnailName;
    const path = `inventory/${this.item.id}`;
    return new Promise(function (resolve, reject) {
      storage
        .ref(`${path}/${file.name}`)
        .put(file, metadata)
        .then(
          (complete) => {
            const urlBase = `https://storage.googleapis.com/${storageBucket}`;

            const result = {
              name: file.name,
              url: `${urlBase}/${path}/${file.name}`,
            };

            // add thumbnails to image result
            let index = 0;
            imageThumbnails.resolutions.forEach((r) => {
              const name = getThumbnailName(file.name, r);
              result[
                `thumbnailUrl${index}`
              ] = `${urlBase}/${path}/${imageThumbnails.path}/${name}`;
              index++;
            });

            console.log(result);
            resolve(result);
          },
          (error) => {
            console.log(error);
            updateStatus(file.name, "error");
            reject(error);
          }
        );
    });
  }

  async deleteImage(image) {
    if (this.item.imageUrl == image.thumbnailUrl1) {
      this.item.imageUrl =
        this.images.length > 1 ? this.images[1].thumbnailUrl1 : "";
    }
    await db.doc(`inventory/${this.item.id}/images/${image.id}`).delete();

    // Delete image from storage
    const path = `inventory/${this.item.id}/${image.name}`;
    await storage.ref(path).delete();

    // Delete thumbnails from storage
    imageThumbnails.resolutions.forEach(async (r) => {
      const name = this.getThumbnailName(image.name, r);
      const path = `inventory/${this.item.id}/${imageThumbnails.path}/${name}`;
      await storage.ref(path).delete();
    });

    this.imagesUpdated();
  }

  getThumbnailName(name, resolution): string {
    const parts = name.split(".");
    let result = "";
    for (let i = 0; i < parts.length; i++) {
      if (i == parts.length - 1) {
        result += "_" + resolution;
      }
      if (i != 0) {
        result += ".";
      }
      result += parts[i];
    }
    return result;
  }

  async imageMoved() {
    // update order on any image that's wrong
    for (let i = 0; i < this.images.length; i++) {
      if (this.images[i].order != i) {
        // dont await, do them fast as we can
        db.collection(`/inventory/${this.item.id}/images`)
          .doc(this.images[i].id)
          .update({ order: i });
      }

      //update primary image if needed
      if (i == 0 && this.item.imageUrl != this.images[i].thumbnailUrl1) {
        inventoryCollection
          .doc(`${this.item.id}`)
          .update({ imageUrl: this.images[i].thumbnailUrl1 });
      }
    }
    this.imagesUpdated();
  }

  async fileUploadComplete(fileResponse) {
    console.log("fileResponse", fileResponse);
  }

  // Used to set a date image was updated for convoy
  imagesUpdated() {
    inventoryCollection
      .doc(`${this.item.id}`)
      .update({ imagesUpdated: Timestamp.now() });
  }
}
